import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getPostsByItemKey = async ({ itemKey }) => {
	if (!itemKey) {
		throw errorOfType(errorTypes.KEYNOTSPECIFIED, 'getPostsByItemKey')
	}
	try {
		const itemPostsQuerySnap = await firestore.collection('items').doc(itemKey).collection('posts').get()
		const postsDocSnaps = await Promise.all(itemPostsQuerySnap.docs.map(itemPostDocSnap => firestore.collection('posts').doc(itemPostDocSnap.ref.id).get()))
		const posts = postsDocSnaps.map(postDocSnap => postDocSnap.data()).filter(post => !post.deleted)

		return { posts }
	} catch (exception) {
		console.log('exception', exception)
		throw errorOfType(errorTypes.UNKNOWNERROR, itemKey, exception)
	}
}

export default getPostsByItemKey



// WEBPACK FOOTER //
// ./src/dataservices/getPostsByItemKey.js